module.exports = __webpack_public_path__ + "img/ada.1b9c50c8.svg";